export enum TitrateConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'titrate/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'titrate/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_DATE = 'titrate/SET_DATE',
  SET_TIME = 'titrate/SET_TIME',
  SET_DATE_TIME = 'titrate/SET_DATE_TIME',
  SET_PTA = 'titrate/SET_PTA',
  SET_ASSESSED_BY = 'titrate/SET_ASSESSED_BY',
  SET_ROLE_PERFORMING = 'titrate/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'titrate/SET_ROLE_PERFORMING_PNNV',
  SET_MEDICATION = 'titrate/SET_MEDICATION',
  SET_OTHER_OPTION = 'titrate/SET_OTHER_OPTION',
  SET_NEW_DOSE = 'titrate/SET_NEW_DOSE',
  SET_RATE = 'titrate/SET_RATE',
  SET_RATE_PNNV = 'titrate/SET_RATE_PNNV',
  SET_ROUTE = 'titrate/SET_ROUTE',
  SET_ROUTE_PNNV = 'titrate/SET_ROUTE_PNNV',
  SET_PROCEDURE_COMPLICATIONS = 'titrate/SET_PROCEDURE_COMPLICATIONS',
  SET_RESPONSE = 'titrate/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'titrate/SET_RESPONSE_PNNV',
  SET_AUTHORIZATION = 'titrate/SET_AUTHORIZATION',
  SET_COMMENTS = 'titrate/SET_COMMENTS',
  SET_TITRATE_STATE = 'titrate/SET_TITRATE_STATE',
  SAVE_TITRATE = 'titrate/SAVE_TITRATE',
  SET_UPDATE_INPUT_ROWS = 'titrate/SET_UPDATE_INPUT_ROWS',
  SET_ADD_TO_TIMELINE = 'titrate/SET_ADD_TO_TIMELINE',
  RESET_TITRATE_STATE = 'titrate/RESET_TITRATE_STATE',
}
